import React from "react";
import {useLotto90} from "../../../store/lotto90/Lotto90Context";

const ResultHistoryMobile = () => {

    const {t, lastResult} = useLotto90()
    return <div className="right-side lotto90v1-h-vw">
        <div className="row recent-result">
            <div className="text-left f-res">{t("labels:ticket.new")}</div>
        </div>

        {
            lastResult && lastResult.map((e, i) => {
                return <div key={i} className="draw-sec">
                    <div className="row ml-2 mt-2">
                        <span className="text-right f-res p-1">{e.drawLabel}</span>
                    </div>
                    <div className="row ml-2 mt-0">
                        {e.posts.map((p, i) => {
                            return <div key={i} className="text-center draw-history">
                                <div id="drawing" className={`lotto90-post-${p.postCode}`}>{p.postCode}</div>
                                <div id="drawing"
                                     className={`num-circle-ticket num-circle-ticket-${p.postCode}`}>{p.number}</div>
                            </div>
                        })}
                    </div>
                </div>
            })
        }

    </div>
}

export default ResultHistoryMobile
